import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../lib/auth';
import { LanguageSwitcher } from '../i18n/LanguageSwitcher';
import './login.css';

export function Login() {
  const { t } = useTranslation('login');
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(event: React.FormEvent) {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(err instanceof Error ? err.message : t('failed'));
      setSubmitting(false);
    }
  }

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={onSubmit}>
        <div className="login-lang">
          <LanguageSwitcher />
        </div>
        <h1 className="login-title">{t('title')}</h1>
        <p className="login-subtitle">{t('subtitle')}</p>

        <label className="login-field">
          <span>{t('email')}</span>
          <input
            type="email"
            autoComplete="username"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoFocus
          />
        </label>

        <label className="login-field">
          <span>{t('password')}</span>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
        </label>

        {error ? (
          <div className="login-error" role="alert">
            {error}
          </div>
        ) : null}

        <button className="login-submit" type="submit" disabled={submitting}>
          {submitting ? t('submitting') : t('submit')}
        </button>
      </form>
    </div>
  );
}
